export function SnsTextGeneration(type: string): string {
  switch (type) {
    case "Twitter":
      return "X";
    case "Tiktok":
      return "TikTok";
    default:
      return type;
  }
}
